/**
 * Money formatting helpers. Amounts are stored as integer cents everywhere
 * (payments.amount_cents, management_invoices.amount_cents, …).
 */

// de-DE so amounts read the same everywhere (AdminAnalytics formats de-DE):
// "1.734,00 €". Keep this the single default; pass a locale to override.
const DEFAULT_LOCALE = "de-DE";

/** Format integer cents as a localized currency string, e.g. 173400 → "1.734,00 €". */
export function formatCents(
  cents: number | null | undefined,
  currency = "eur",
  locale = DEFAULT_LOCALE
): string {
  const value = (cents ?? 0) / 100;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(value);
}

/** Format a euro (major-unit) number, e.g. 1734 → "1.734,00 €". */
export function formatEuro(
  amount: number | null | undefined,
  locale = DEFAULT_LOCALE
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
  }).format(amount ?? 0);
}
